export const LOAD_PROVIDER_OPTIONS = [
  { label: 'Default (Resound for Globe, Digilink for Smart/Sun/TNT)', value: '0' },
  { label: 'Digilink (Digilink For All Network)', value: '1' },
  { label: 'Resound (Resound For All Network)', value: '2' },
];

export const NETWORK_PROVIDER_OPTIONS = [
  { label: 'Smart', value: '1' },
  { label: 'Globe', value: '2' },
  { label: 'Sun', value: '3' },
  { label: 'TNT', value: '4' },
  { label: 'Smart Bro', value: '5' },
  { label: 'Kuryente Load', value: '6' },
  { label: 'Cignal', value: '7' },
  { label: 'DITO', value: '8' },
  { label: 'TM', value: '9' },
  { label: 'SatLite ', value: '10'},
  { label: 'Cignal Play TV', value: '11'},
  { label: 'Cignal HD Kit', value: '12'}
];

export const NETWORK_PROVIDER_PINS_OPTIONS = [
  { label: 'Smart', value: '1' },
  { label: 'Globe', value: '2' },
  { label: 'Sun', value: '3' },
  { label: 'TNT', value: '4' },
  { label: 'Smart Bro', value: '5' },
  { label: 'DITO', value: '8' },
  { label: 'TM', value: '9' },
];

export const ITEM_TYPE_OPTIONS = [
  { label: 'Promo', value: '1' },
  { label: 'Load', value: '2' },
  { label: 'Text', value: '3' },
  { label: 'Combo', value: '4' },
  { label: 'Meralco', value: '5' },
  { label: 'Cignal', value: '6' },
  { label: 'Cignal PPV', value: '7' },
  { label: 'Pins', value: '8' },
  { label: 'Entertainment', value: '9' },
];


export const ADMIN_PORTAL_TAB_OPTIONS = [
  { label: 'Select an Option', value: null },
  { label: 'ADS DASHBOARD', value: 'ADS DASHBOARD' },
  { label: 'ANNOUNCEMENT', value: 'ANNOUNCEMENT' },
  { label: 'SKU\'s/BILLERS DASHBOARD', value: 'SKU\'s/BILLERS DASHBOARD' },
  { label: 'Accounts', value: 'Accounts' },
  { label: 'PORTAL ACCOUNT', value: 'PORTAL ACCOUNT' },
  { label: 'TRANSFER FUND', value: 'TRANSFER FUND' },
  { label: 'PUSH NOTIFICATION', value: 'PUSH NOTIFICATION' },
  { label: 'KYC LOGS', value: 'KYC LOGS' },
  { label: 'ALL TRANSACTIONS', value: 'ALL TRANSACTIONS' },
  { label: 'BUY LOAD', value: 'BUY LOAD' },
  { label: 'KYC REGISTRATION', value: 'KYC REGISTRATION' },
  { label: 'CASH IN', value: 'CASH IN' },
  { label: 'STORE PURCHASE', value: 'STORE PURCHASE' },
  { label: 'PAY BILLS', value: 'PAY BILLS' },
  { label: 'MEGA REWARDS', value: 'MEGA REWARDS' },
  { label: 'OVERVIEW', value: 'OVERVIEW' },
  { label: 'CASH IN TRANSACTIONS', value: 'CASH IN TRANSACTIONS' },
  { label: 'SUMMARY REPORTS', value: 'SUMMARY REPORTS' },
  { label: 'CASH OUT TRANSACTIONS', value: 'CASH OUT TRANSACTIONS' },
  { label: 'TOP USERS', value: 'TOP USERS' },
  { label: 'DAILY SALES REPORTS', value: 'DAILY SALES REPORTS' },
  { label: 'REFERRAL COMMISSION', value: 'REFERRAL COMMISSION' },
  { label: 'PORTAL USER LOGS', value: 'PORTAL USER LOGS' },
  { label: 'N/A', value: 'N/A' },
  { label: 'LOGIN PAGE', value: 'LOGIN PAGE' },
  { label: 'RESET PASSWORD PAGE', value: 'RESET PASSWORD PAGE' },
  { label: 'SYSTEM MAINTENANCE', value: 'SYSTEM MAINTENANCE' },
  { label: 'PROFANITY FILTER', value: 'PROFANITY FILTER' },
];

export const BILLER_CATEGORY_OPTIONS = [
  { label: '== Select an option ==', value: null },
  { label: 'Telecom', value: '2' },
  { label: 'Credit Card', value: '3' },
  { label: 'Cable and Internet', value: '4' },
  { label: 'Government', value: '5' },
  { label: 'Loans', value: '6' },
  { label: 'Others', value: '7' },
  { label: 'Travel', value: '8' },
  { label: 'Transpo', value: '9' },
  { label: 'Shopping', value: '10' },
  { label: 'Power', value: '11' },
  { label: 'Water', value: '12' },
];

export const FIELD_FORMAT_OPTIONS = [
  { label: '== Select an option ==', value: null },
  { label: 'Numeric', value: '1' },
  { label: 'Alphanumeric', value: '2' },
];
